import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import { throttle } from "lodash";
import "./index.css";

export interface Props {
    options?: echarts.EChartsOption,
    colors?: string[],
    showTotal?: boolean
    data: { value: number, name: string }[],
    size?: "small" | "medium-smallFarLegend" | "mediumFarLegend" | "medium" | "big",
    renderValue?: Function
    onClick?: Function,
    styleLegend?: React.CSSProperties,
    styleChart?: React.CSSProperties,
    styleGeral?: React.CSSProperties,
    legendBadgeSmall?: boolean,
}

const ChartDonut: React.FC<Props> = (props) => {
    const chartDom = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (chartDom.current && props.options) {
            const myChart = echarts.init(chartDom.current, undefined, { renderer: "svg" });
            myChart.setOption(props.options);

            const resizeObserver = new ResizeObserver(throttle(() => {
                myChart.resize();
            }, 5000));

            resizeObserver.observe(chartDom.current);

            return () => {
                if (chartDom.current) {
                    resizeObserver.unobserve(chartDom.current);
                }
            };
        }
    }, [props.options]);

    const handleClick = (item: any) => {
        props.onClick && props.onClick(item)
    }

    return (
        <div className={`hhchart donut ${props.size || "medium"}`} style={props.styleGeral && props.styleGeral}>
            <div className={"chart"} style={props.styleChart && props.styleChart}>
                <div className={"body"} ref={chartDom as any} ></div>
                {
                    props.showTotal &&
                    <span className={"total"}>
                        {
                            props.renderValue
                                ? props.renderValue(props.data.reduce((t, s) => { return t + s.value }, 0))
                                : props.data.reduce((t, s) => { return t + s.value }, 0)
                        }
                    </span>
                }
            </div>
            <div className={"legend"} style={props.styleLegend && props.styleLegend}>
                {
                    props.data.map((item, i) => {
                        return (
                            <div
                                className={"item"}
                                key={i}
                                style={{ cursor: (props.onClick) ? "pointer" : undefined }}
                                onClick={() => handleClick(item)}
                            >
                                <span
                                    className={`badge ${[props.legendBadgeSmall ? "small" : ""]}`}
                                    style={{ background: props.colors && props.colors[i] }}
                                >
                                    {props.renderValue ? props.renderValue(item.value) : item.value}
                                </span>
                                <span className={"name"} style={{ fontSize: "14px", paddingLeft: "10px" }} >{item.name}</span>
                            </div>
                        );
                    })}
            </div>
        </div >
    )
}

export default ChartDonut;